var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Dados do Cálculo:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _vm.exibeObs
            ? _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Munícipio:",
                      content:
                        _vm.dadosVtn.pvtn.municipio
                          .nomeComCodigoEstadoFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Módulo fiscal do Município (MF):",
                      content: _vm.dadosVtn.pvtn.municipio.mf,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Área Requerida (A):",
                      content: _vm.dadosVtn.areaRequeridaFormatada,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Número de módulos fiscais:",
                      content: _vm.dadosVtn.nmoduloFiscal,
                      toolTip: "left-end",
                      textIcon: _vm.numeroModulosFiscais(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Percentual a ser aplicado sobre o VTN:",
                      content: _vm.dadosVtn.percentualAplicadoFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.percentualAplicadoVtn(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Coeficiente Angular:",
                      content: _vm.dadosVtn.coeficienteAngularFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.coeficienteAngular(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Coeficiente Linear:",
                      content: _vm.dadosVtn.coeficienteLinearFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.coeficienteLinear(),
                      contentAlignRight: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Valor mínimo da Pauta de VTN (PVTN):",
                      content: "" + _vm.dadosVtn.pvtn.vtnPorHaMinFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Percentual do bônus utilizado no cálculo:",
                      content: _vm.intervaloPercentual,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Prazo mínimo de inalienabilidade do imóvel:",
                      content: _vm.getPrazoMinimo,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Pagamento:",
                      content: "até 20 (vinte) parcelas anuais e sucessivas",
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Juros:",
                      content: _vm.jurosText,
                      toolTip: "left-end",
                      textIcon: _vm.juros(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Carência:",
                      content: _vm.carenciaText,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor Final do Imóvel (VFI):",
                      content: _vm.formataMoeda(_vm.dadosVtn.valorFinalImovel),
                      contentAlignRight: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Detalhamento da dívida:")])
          ]),
          _c("div", { attrs: { id: "line" } }),
          _c(
            "el-row",
            { staticClass: "espacamento" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.valorFinalImovelFormatado
                    ? _c("app-display", {
                        attrs: {
                          label: "Valor Final do Imóvel (VFI):",
                          content: _vm.dadosVtn.valorFinalImovelFormatado
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.parcelasAp
                    ? _c("app-display", {
                        attrs: {
                          label: "Total de Correção anual:",
                          content: _vm.totalCorrecaoAnual,
                          textIcon:
                            "O valor da correção monetária será atualizada e exibida anualmente.",
                          toolTip: "right"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.valorFinalAposCarencia
                    ? _c("app-display", {
                        attrs: {
                          label: "Valor Final do Imóvel após carência (VFI):",
                          content: _vm.formataMoeda(
                            _vm.dadosVtn.valorFinalAposCarencia
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.parcelasAp
                    ? _c("app-display", {
                        attrs: {
                          label: "Valor da Prestação:",
                          content: _vm.dadosVtn.parcelasAp[0].valorFormatado,
                          textIcon:
                            "O valor da prestação poderá haver reajustes conforme a correção monetária que será atualizada e exibida anualmente.",
                          toolTip: "right"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.taxaJurosFormatada
                    ? _c("app-display", {
                        attrs: {
                          label: "Taxa de Juros Anual (i):",
                          content: _vm.dadosVtn.taxaJurosFormatada
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.parcelasAp
                    ? _c("app-display", {
                        attrs: {
                          label: "Total pago no final:",
                          content: _vm.totalValoresParcelas.toLocaleString(
                            "pt-BR",
                            { style: "currency", currency: "BRL" }
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.dadosVtn.parcelasAp
                    ? _c("app-display", {
                        attrs: {
                          label: "Total de juros:",
                          content: (
                            _vm.totalValoresParcelas -
                            _vm.dadosVtn.valorFinalAposCarencia
                          ).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL"
                          }),
                          textIcon:
                            "Juros referentes às parcelas e período de carência.",
                          toolTip: "right"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("tabela-amortizacao", {
            staticClass: "espacamento",
            attrs: { dados: _vm.dadosAmortizacao, disableCheck: [] }
          })
        ],
        1
      ),
      _vm.exibeCardObs && _vm.dadosVtn.status === "Aguardando cálculo"
        ? _c("observacoes", { staticClass: "espacamento" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d353d4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d353d4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/DadosModalAP.vue
// module id = null
// module chunks = 